<style lang="scss" scoped>
.feed-content {
    height: 335px;
    overflow-y: auto;
    overflow-x: hidden;
}
.tabs {
    @media only screen and (max-width: 767px) {
        margin: 0 -7.5px;
    }
    .tab {
        @media only screen and (max-width: 767px) {
            width: 50%;
            width: calc(50% - 16px);
            margin: 0 7.5px;
        }
    }
}
</style>

<template>
    <div>

        <!-- Header -->
        <div class="d-flex flex-wrap mb-32 tabs">
            <div class="tab px-8 px-md-24 py-8 mr-8 text-primary-dark opacity-50 c-pointer" @click="filter = 'all'; getAll(true)" :class="{ 'bg-white-hover opacity-100' : filter === 'all' }">
                {{ $t('pages.dashboard.all_notifications') }}
                <span class="opacity-50 ml-8">{{ numbers.total || 0 }}</span>
            </div>
            <div class="tab px-8 px-md-24 py-8 mr-8 text-primary-dark opacity-50 c-pointer" @click="filter = 'red'; getRed(true)" :class="{ 'bg-white-hover opacity-100' : filter === 'red' }">
                <span class="d-inline-block mr-8" style="width: 11px; height: 11px; background-color: #ff2d55; border-radius: 50%;"></span>
                {{ $t('pages.dashboard.red') }}
                <span class="opacity-50 ml-8">{{ numbers.total_high || 0  }}</span>
            </div>
            <div class="tab px-8 px-md-24 py-8 mr-8 text-primary-dark opacity-50 c-pointer" @click="filter = 'orange'; getOrange(true)" :class="{ 'bg-white-hover opacity-100' : filter === 'orange' }">
                <span class="d-inline-block mr-8" style="width: 11px; height: 11px; background-color: #ffbd26; border-radius: 50%;"></span>
                {{ $t('pages.dashboard.orange') }}
                <span class="opacity-50 ml-8">{{ numbers.total_medium || 0  }}</span>
            </div>
            <div class="tab px-8 px-md-24 py-8 mr-8 text-primary-dark opacity-50 c-pointer" @click="filter = 'todo';  getTodo(true)" :class="{ 'bg-white-hover opacity-100' : filter === 'todo' }">
                {{ $t('pages.dashboard.todo') }}
                <span class="opacity-50 ml-8">{{ numbers.total_to_do || 0 }}</span>
            </div>
            <div class="tab px-8 px-md-24 py-8 mr-8 text-primary-dark opacity-50 c-pointer" @click="filter = 'done'; getDone(true)" :class="{ 'bg-white-hover opacity-100' : filter === 'done' }">
                {{ $t('pages.dashboard.done') }}
                <span class="opacity-50 ml-8">{{ numbers.total_done || 0 }}</span>
            </div>
        </div>

        <!-- Content -->
        <div class="feed-content">
            <template v-if="filteredItems.data.length > 0">
                <feed-item v-for="item in filteredItems.data" :key="item.id" :data="item" v-model="item.done" @input="handleStatusChanged(item)"></feed-item>
                <a v-if="!loading && filteredItems.meta.current_page < filteredItems.meta.last_page" href="javascript:void(0)" @click="handle_function_call(`get${capitalize(filter)}`)" class="text-center text-primary w-100 d-block"> Laad meer </a>
                <span class="d-block text-center text-gray" v-else-if="loading && filteredItems.meta.current_page < filteredItems.meta.last_page">Laden ...</span>
                <span class="d-block text-center text-gray border-top mx-150 pt-8" v-else>Er zijn geen notificaties meer</span>
            </template>
            <template v-else>
                <p class="text-center text-gray">Geen notificaties gevonden</p>
            </template>
        </div>

    </div>
</template>

<script>
import FeedItem from '@/components/feed/feed-item'

export default {
    components: { FeedItem },

    props: {
        numbers: {
            required: true,
        }
    },

    data: () => ({
        loading: false,

        filter: 'todo',
        all: { data: [], meta: { current_page: 0 } },
        todo: { data: [], meta: { current_page: 0 } },
        done: { data: [], meta: { current_page: 0 } },
        red: { data: [], meta: { current_page: 0 } },
        orange: { data: [], meta: { current_page: 0 } },
    }),
    mounted() {
        this.getTodo()
    },
    methods: {
        getAll(initial) {
            if (initial && this.all.data.length !== 0) return
            this.getActions({ page: this.all.meta.current_page + 1 }).then((actions) => {
                this.all.data = [...this.all.data, ...actions.data]
                this.all.meta = actions.meta
            })
        },
        getTodo(initial) {
            if (initial && this.todo.data.length !== 0) return
            this.getActions({ done: 0, page: this.todo.meta.current_page + 1 }).then((actions) => {
                this.todo.data = [...this.todo.data, ...actions.data]
                this.todo.meta = actions.meta
            })
        },
        getDone(initial) {
            if (initial && this.done.data.length !== 0) return
            this.getActions({ done: 1, page: this.done.meta.current_page + 1 }).then((actions) => {
                this.done.data = [...this.done.data, ...actions.data]
                this.done.meta = actions.meta
            })
        },
        getRed(initial) {
            if (initial && this.red.data.length !== 0) return
            this.getActions({ priority: 2,  done: 0, page: this.red.meta.current_page + 1 }).then((actions) => {
                this.red.data = [...this.red.data, ...actions.data]
                this.red.meta = actions.meta
                this.numbers.total_high = actions.data.length
            })
        },
        getOrange(initial) {
            if (initial && this.orange.data.length !== 0) return
            this.getActions({ priority: 1, page: this.orange.meta.current_page + 1 }).then((actions) => {
                this.orange.data = [...this.orange.data, ...actions.data]
                this.orange.meta = actions.meta
            })
        },
        getActions(filter) {
            return this.$store.dispatch('admins/actionsIndex', filter).then((actions) => {
                return actions
            })
        },
        handle_function_call(function_name) {
            this[function_name]()
        },
        capitalize(s) {
            if (typeof s !== 'string') return ''
            return s.charAt(0).toUpperCase() + s.slice(1)
        },
        handleStatusChanged(item) {

            if (item.done) {
                this.numbers.total_done++
                this.numbers.total_to_do--
                this.todo.data.splice(this.todo.data.findIndex((i) => i.id === item.id), 1)
                if (this.todo.data.findIndex((i) => i.id === item.id) !== -1) this.todo.data.push(item)
                return
            }

            if (!item.done) {
                this.numbers.total_done--
                this.numbers.total_to_do++
                this.done.data.splice(this.done.data.findIndex((i) => i.id === item.id), 1)
                if (this.done.data.findIndex((i) => i.id === item.id) !== -1) this.todo.data.push(item)
                return
            }
        }
    },
    computed: {
        filteredItems() {
            return this[this.filter]
        }
    }
}
</script>
